import { useState } from 'react';
import {
    Collapse,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Popover,
    Tooltip
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { createNewView, onHandlerShowView } from '@/component/ticketList/handler/HelpDeskViewHandler';
import { getViewDisplayName } from '@/common/utils/ViewUtils';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function AddViewHelpdeskList(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [addViewPopover, setAddViewPopover] = useState(null);
    const isOpenFormTypePopover = Boolean(addViewPopover);
    const id = isOpenFormTypePopover ? 'simple-popover' : undefined;

    const {
        setIsLoading,
        element,
        getVisibleWidth,
        listView,
        openListViewHide,
        setOpenListViewHide
    } = props;

    const onClickAddNewView = async () => {
        setIsLoading(true);
        setAddViewPopover(null);
        createNewView(props).then(() => {
            setIsLoading(false);
            let nodeListViews = document.querySelectorAll('.item-helpdesk');
            let containerRect = element.getBoundingClientRect();
            let posElem = [];
            for (let i = 0; i < nodeListViews.length; i++) {
                // Gets the amount of pixels currently visible within the container
                let visiblePageWidth = getVisibleWidth(nodeListViews[i]);
                posElem.push({ pos: visiblePageWidth });
            }
            element.scrollLeft +=
                posElem[posElem.length - 1]?.pos.width -
                (containerRect.width - posElem[posElem.length - 1].pos.left);
        });
    };

    const handleClickOpenListViewHide = () => {
        let listViewHide = listView.filter(view => view.status === Constant.STATUS_VIEW.HIDDEN);
        if (!Utils.isEmptyArray(listViewHide)) {
            setOpenListViewHide(!openListViewHide);
        } else {
            setOpenListViewHide(false);
        }
    };

    return (
        <>
            <div className="btnAdd-viewTabs">
                <IconButton
                    className="btnAdd-views"
                    onClick={event => setAddViewPopover(event.currentTarget)}
                >
                    <img src="/assets/image/icon-add-plus.svg" alt=""></img>
                </IconButton>
            </div>

            <Popover
                className="viewList-action"
                id={id}
                open={isOpenFormTypePopover}
                anchorEl={addViewPopover}
                onClose={e => setAddViewPopover(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <div className="add-view-more">
                    <List>
                        <ListItem disablePadding onClick={onClickAddNewView}>
                            <ListItemText primary={tr('新規追加')} />
                        </ListItem>
                        <ListItem disablePadding onClick={handleClickOpenListViewHide}>
                            <ListItemText primary={tr('非表示ビュー一覧')} />
                            {openListViewHide ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={openListViewHide} timeout="auto" unmountOnExit>
                            <List className="listView-hide">
                                {!Utils.isEmptyArray(listView) &&
                                    listView.map(view => {
                                        let viewName = getViewDisplayName(view);
                                        return (
                                            view.status === Constant.STATUS_VIEW.HIDDEN && (
                                                <ListItem
                                                    key={view.id}
                                                    onClick={() =>
                                                        onHandlerShowView(view, props, setAddViewPopover)
                                                    }
                                                >
                                                    <Tooltip
                                                        title={viewName}
                                                        placement="right"
                                                        arrow
                                                        interactive
                                                    >
                                                        <ListItemText primary={viewName} />
                                                    </Tooltip>
                                                </ListItem>
                                            )
                                        );
                                    })}
                            </List>
                        </Collapse>
                    </List>
                </div>
            </Popover>
        </>
    );
}
